import {PolicyMasterList} from "./PolicyMasterList";
import {PolicyMasterEdit} from "./PolicyMasterEdit";
import {PolicyMasterCreate} from "./PolicyMasterCreate";

export default {
    list: PolicyMasterList,
    create: PolicyMasterCreate,
    edit: PolicyMasterEdit
};
